import script from "./ReviewManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewManagement.vue?vue&type=script&setup=true&lang=js"

import "./ReviewManagement.vue?vue&type=style&index=0&id=27a35183&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27a35183"]])

export default __exports__